import paginationPage from './pagination.vue';

const pageination = {
    install:function(Vue) {
        Vue.component('pageination', paginationPage)
    }
}

export default pageination;